import { makeApi } from "@zodios/core";
import { z } from "zod";

export const backofficeBankingInformationApi = makeApi([
  {
    method: "post",
    path: "/site/:siteId/resend-token",
    response: z.any(),
    alias: "resendBankingInformationToken",
    parameters: [
      {
        type: "Path",
        name: "siteId",
        schema: z.number(),
      },
    ],
  },
]);
